import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { StateManagementService } from "../../../providers/state-management/state-management.service";

@Component({
  selector: "flacc-tool",
  templateUrl: "flacc-tool.html",
})
export class FlaccToolComponent implements OnInit {
  @Input() readonly: boolean = false;
  @Output() onValueUpdate: EventEmitter<any> = new EventEmitter();

  formGroup: FormGroup;

  faceConfig = {};
  legsConfig = {};
  activityConfig = {};
  cryConfig = {};
  consolabilityConfig = {};
  constructor(
    public formBuilder: FormBuilder,
    public stateData: StateManagementService
  ) {
    this.formGroup = this.formBuilder.group({});
    this.formGroup.addControl("flaccFace", this.formBuilder.control(undefined));
    this.formGroup.addControl("flaccLegs", this.formBuilder.control(undefined));
    this.formGroup.addControl(
      "flaccActivity",
      this.formBuilder.control(undefined)
    );
    this.formGroup.addControl("flaccCry", this.formBuilder.control(undefined));
    this.formGroup.addControl(
      "flaccConsolability",
      this.formBuilder.control(undefined)
    );

    this.formGroup.valueChanges.subscribe((data) => {
      let cuurentValue: boolean = false;
      let severity = 0;
      let allNull = true;
      for (let field of Object.keys(data)) {
        severity += data[field] * 1;
        if (data[field] !== null) {
          allNull = false;
          if (data[field] > 0) cuurentValue = true;
        }
      }
      if (cuurentValue == true) this.stateData.setMyData(1);
      else this.stateData.setMyData(0);

      this.onValueUpdate.emit({
        values: data,
        severity: allNull ? null : severity,
      });
    });
  }

  ngOnInit(): void {
    let options = ["0", "1", "2"];

    this.faceConfig["id"] = "flaccFace";
    this.faceConfig["componentId"] = "flaccFace";
    this.faceConfig["readonly"] = this.readonly;
    this.faceConfig["options"] = options;
    this.faceConfig["descriptions"] = {
      "0": "flacc0Face",
      "1": "flacc1Face",
      "2": "flacc2Face",
    };

    this.legsConfig["id"] = "flaccLegs";
    this.legsConfig["componentId"] = "flaccLegs";
    this.legsConfig["readonly"] = this.readonly;
    this.legsConfig["options"] = options;
    this.legsConfig["descriptions"] = {
      "0": "flacc0Legs",
      "1": "flacc1Legs",
      "2": "flacc2Legs",
    };

    this.activityConfig["id"] = "flaccActivity";
    this.activityConfig["componentId"] = "flaccActivity";
    this.activityConfig["readonly"] = this.readonly;
    this.activityConfig["options"] = options;
    this.activityConfig["descriptions"] = {
      "0": "flacc0Activity",
      "1": "flacc1Activity",
      "2": "flacc2Activity",
    };

    this.cryConfig["id"] = "flaccCry";
    this.cryConfig["componentId"] = "flaccCry";
    this.cryConfig["readonly"] = this.readonly;
    this.cryConfig["options"] = options;
    this.cryConfig["descriptions"] = {
      "0": "flacc0Cry",
      "1": "flacc1Cry",
      "2": "flacc2Cry",
    };

    this.consolabilityConfig["id"] = "flaccConsolability";
    this.consolabilityConfig["componentId"] = "flaccConsolability";
    this.consolabilityConfig["readonly"] = this.readonly;
    this.consolabilityConfig["options"] = options;
    this.consolabilityConfig["descriptions"] = {
      "0": "flacc0Consolability",
      "1": "flacc1Consolability",
      "2": "flacc2Consolability",
    };
  }

  @Input() set existingData(data: object) {
    if (data && data["tool"] === "flacc" && data["values"]) {
      this.formGroup.setValue(data["values"]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/flacc-tool/flacc-tool.ts